import { render, staticRenderFns } from "./UploadFileGerencia.vue?vue&type=template&id=2a93cdf8&scoped=true"
import script from "./UploadFileGerencia.vue?vue&type=script&lang=js"
export * from "./UploadFileGerencia.vue?vue&type=script&lang=js"
import style0 from "./UploadFileGerencia.vue?vue&type=style&index=0&id=2a93cdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93cdf8",
  null
  
)

export default component.exports